import { useState } from "react";
import { motion } from "framer-motion";
import { Play, Camera, X } from "lucide-react";
import { Dialog, DialogContent } from "@/components/ui/dialog";

const WORKS = [
  { id: "w1", title: "Marka Reklam Filmi", tag: "Reklam Filmi", type: "Film",
    img: "https://images.unsplash.com/photo-1515634928627-2a4e0dae3ddf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: "w2", title: "Kurumsal Tanıtım", tag: "Tanıtım Filmi", type: "Film",
    img: "https://images.unsplash.com/photo-1554941829-202a0b2403b8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: "w3", title: "Düğün Hikâyesi", tag: "Düğün Filmi", type: "Film",
    img: "https://images.unsplash.com/photo-1629756048377-09540f52caa1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: "w4", title: "Ürün Çekimi", tag: "Ürün Fotoğrafı", type: "Fotoğraf",
    img: "https://images.unsplash.com/photo-1545242640-7c9e9cc07d23?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: "w5", title: "Moda Editoryal", tag: "Moda Çekimi", type: "Fotoğraf",
    img: "https://images.unsplash.com/photo-1633381521050-26bb467d9d5a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: "w6", title: "Stüdyo Portre", tag: "Portre", type: "Fotoğraf",
    img: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
];

const FILTERS = ["Tümü", "Film", "Fotoğraf"];

export function Portfolio() {
  const [filter, setFilter] = useState("Tümü");
  const [selected, setSelected] = useState(null);

  const items = filter === "Tümü" ? WORKS : WORKS.filter((w) => w.type === filter);

  return (
    <section id="portfolyo" className="max-w-7xl mx-auto px-6 py-24 border-t border-white/5" data-testid="portfolio-section">
      <div className="flex flex-wrap items-end justify-between gap-6 mb-12">
        <div>
          <p className="text-sm uppercase tracking-[0.3em] text-gold mb-3">Çalışmalarımız</p>
          <h2 className="font-serif text-4xl lg:text-5xl max-w-xl">Perdeye taşıdığımız hikâyelerden bir seçki.</h2>
        </div>
        <div className="flex gap-2">
          {FILTERS.map((f) => (
            <button key={f} onClick={() => setFilter(f)} data-testid={`portfolio-filter-${f}`}
              className={`text-xs uppercase tracking-wider px-4 py-2 rounded-full border transition-colors ${
                filter === f ? "bg-gold text-black border-gold" : "border-white/15 text-white/60 hover:border-gold/40"
              }`}>
              {f}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.map((w, i) => (
          <motion.button
            key={w.id}
            layout
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.06 }}
            onClick={() => setSelected(w)}
            data-testid={`portfolio-item-${w.id}`}
            className="group relative rounded-xl overflow-hidden aspect-[4/3] text-left focus:outline-none focus:ring-2 focus:ring-gold"
          >
            <img src={w.img} alt={w.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
            <span className="absolute top-3 left-3 text-[11px] uppercase tracking-wider px-3 py-1 rounded-full bg-black/50 border border-white/15 text-gold backdrop-blur-sm">
              {w.tag}
            </span>
            <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
              <span className="w-14 h-14 rounded-full bg-gold/90 text-black flex items-center justify-center shadow-[0_0_30px_rgba(212,175,55,0.5)]">
                {w.type === "Film" ? <Play className="w-6 h-6 ml-0.5" /> : <Camera className="w-6 h-6" />}
              </span>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <h3 className="font-serif text-2xl text-white">{w.title}</h3>
            </div>
          </motion.button>
        ))}
      </div>

      <Dialog open={!!selected} onOpenChange={(o) => !o && setSelected(null)}>
        <DialogContent className="bg-[#0A0A0A] border-white/10 max-w-3xl p-0 overflow-hidden" data-testid="portfolio-lightbox">
          {selected && (
            <div>
              <div className="relative aspect-video">
                <img src={selected.img} alt={selected.title} className="absolute inset-0 w-full h-full object-cover" />
                <button onClick={() => setSelected(null)} data-testid="lightbox-close"
                  className="absolute top-3 right-3 w-9 h-9 rounded-full bg-black/60 border border-white/20 text-white flex items-center justify-center hover:text-gold">
                  <X className="w-4 h-4" />
                </button>
              </div>
              <div className="p-6">
                <span className="text-xs uppercase tracking-wider text-gold">{selected.tag}</span>
                <h3 className="font-serif text-3xl mt-1">{selected.title}</h3>
                <p className="text-white/50 text-sm mt-3">
                  İnce Fikirler AI Studio prodüksiyonu. Örnek çalışma — kendi projenizi başlatmak için hemen kaydolun.
                </p>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
}
